"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
// https://github.com/ericgio/react-bootstrap-typeahead/blob/master/docs/API.md
var react_1 = __importStar(require("react"));
var react_bootstrap_typeahead_1 = require("react-bootstrap-typeahead");
var DropDownCountries = function (_a) {
    var selectedProps = _a.selectedProps, dataset = _a.dataset, defaultValue = _a.defaultValue, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, _c = _a.allowNew, allowNew = _c === void 0 ? false : _c, _d = _a.IsResultHighlightOnly, IsResultHighlightOnly = _d === void 0 ? true : _d, handleSelectedItem = _a.handleSelectedItem, _e = _a.placeHolderValue, placeHolderValue = _e === void 0 ? "Choose Item..." : _e, labelKey = _a.labelKey, dependentOn = _a.dependentOn;
    // Selected value
    var _f = (0, react_1.useState)(selectedProps), selected = _f[0], setSelected = _f[1];
    var ref = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        if (selectedProps[0] !== "") {
            setSelected(selectedProps);
        }
    }, [selectedProps]);
    // useEffect - Clear the component when is disable prop changes
    (0, react_1.useEffect)(function () {
        if (isDisabled === true) {
            ref.current.clear();
        }
        return function () { };
    }, [isDisabled]);
    // Filter dataset
    var filterBy = function (option, state) {
        if (state.selected.length) {
            return true;
        }
        return option.name.toLowerCase().indexOf(state.text.toLowerCase()) > -1;
    };
    // Handle select - callback
    var handleSelect = function (selectedValue) {
        setSelected(selectedValue);
        if (selectedValue) {
            // Call back function to return the value to parent component
            handleSelectedItem(selectedValue);
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: (0, jsx_runtime_1.jsx)(react_bootstrap_typeahead_1.Typeahead
        //selected
        , { 
            //selected
            selected: selected, 
            //
            id: "toggle-example", 
            // The labelKey prop specifies the string that will be used for searching and rendering options and selections.
            labelKey: labelKey, 
            // Allows new input not on suggestion list
            allowNew: allowNew, 
            // Indicate whether an asynchronous data fetch is happening.
            isLoading: false, 
            // https://github.com/ericgio/react-bootstrap-typeahead/blob/master/docs/Filtering.md#filterby-arraystring--function
            filterBy: filterBy, 
            // Full set of options, including any pre-selected options.
            options: dataset, 
            // Place holder text for the input.
            placeholder: placeHolderValue, 
            // handle selected item
            onChange: handleSelect, 
            // The selected option(s) displayed in the input. Use this prop if you want to control the component via its parent.
            defaultSelected: defaultValue, 
            // Whether to disable the input.
            disabled: isDisabled, 
            // 	Highlights the menu item if there is only one result and allows selecting that item by hitting enter.
            highlightOnlyResult: IsResultHighlightOnly, 
            // Object Reference
            ref: ref, emptyLabel: "Filter ".concat(dependentOn, " to get results...") }) }));
};
exports.default = DropDownCountries;
